import type { EmployeeIncomePremiumWGAERD } from '../../../../../../../../hooks';
import React from 'react';
import type { CalculationsCardProps } from '../CalculationsCard';
import { CalculationsCard } from '../../../EmployeePensionTab/components';
import { TranslationKeys } from '../../../../../../../../translations';
import { FilterNegativeValues } from '../../../../../../../../utils/formatter/currencyFormatter';

type EmployeeIncomePremiumWGAPanelProps = {
  loading?: boolean;
  data: EmployeeIncomePremiumWGAERD | undefined;
  onChangeCalculations: (field: any) => void;
};

export const EmployeeIncomePremiumsWGAERD = ({
  loading = false,
  data,
  onChangeCalculations,
}: EmployeeIncomePremiumWGAPanelProps) => {
  const cardFields = React.useMemo<CalculationsCardProps['fields']>(() => {
    if (data && 'message' in data) {
      return [];
    }

    return [
      {
        labelId: TranslationKeys.premiumWgaErd_policyNumber,
        formulaId: '',
        type: 'input',
        debounceTime: 1000,
        value: {
          value: data?.policyNumber,
          type: 'identifier',
        },
      },
      {
        labelId: TranslationKeys.employees_income_premiumPerYearWGAERD,
        formulaId: TranslationKeys.employees_income_premiumPerYearWGAERDFormula,
        value: {
          value: FilterNegativeValues(data?.premiumPerYearWgaErd),
          type: 'currency',
        },
      },
      {
        labelId: TranslationKeys.employees_income_premiumPerMonthWGAERD,
        formulaId: TranslationKeys.employees_income_premiumPerMonthWGAERDFormula,
        value: {
          value: FilterNegativeValues(data?.premiumPerMonthWgaErd),
          type: 'currency',
        },
      },
    ];
  }, [data]);

  return (
    <CalculationsCard
      isLoading={loading}
      titleId={TranslationKeys.employees_detail_premiumWGAERD}
      fields={cardFields}
      onChangeCalculations={onChangeCalculations}
      error={data?.message}
    />
  );
};
